import { Controller, useFormContext } from 'react-hook-form';
import { Spin } from 'antd';
import { AlimtalkSendFormValues } from '../../../types/alimtalk/form';
import { AlimtalkTemplateList } from '../../../types/alimtalk/template';
import * as Styled from './style';

export type TemplateSelectorProps = {
  templateList: AlimtalkTemplateList;
  isLoading: boolean;
};

export const TemplateSelector = (props: TemplateSelectorProps) => {
  const { templateList, isLoading } = props;
  const { control } = useFormContext<AlimtalkSendFormValues>();

  return (
    <Styled.Section>
      <Styled.SectionTitle>발송 유형 선택</Styled.SectionTitle>
      <Styled.SelectorCaption>발송 방식에 따라 아래 설정 항목이 달라집니다.</Styled.SelectorCaption>
      {isLoading ? (
        <Spin />
      ) : (
        <Controller
          control={control}
          name="templateId"
          render={({ field }) => (
            <Styled.TypeGrid>
              {templateList.map((template) => (
                <Styled.TypeCard
                  key={template.id}
                  type="button"
                  aria-pressed={field.value === template.id}
                  $selected={field.value === template.id}
                  onClick={() => field.onChange(template.id)}
                >
                  <Styled.TypeName>{template.name}</Styled.TypeName>
                  <Styled.TypeDesc>
                    {/* templateCode(U77 등)는 비즈엠 내부 코드라 노출하지 않고, 발송 여부만 안내 */}
                    {template.templateCode ? '알림톡 발송' : '알림톡 없음 · 쿠폰만 발급'}
                  </Styled.TypeDesc>
                </Styled.TypeCard>
              ))}
            </Styled.TypeGrid>
          )}
        />
      )}
    </Styled.Section>
  );
};
